import { Resourceful } from "../../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { ISystemContext } from "../../Context/SystemContext";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Size, CreateElement, Scale, Log, LogGroup } from "../../MyHelpers";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { titleParamsFeature } from "./titleParamsFeature";
import { IRandomInterval } from "../../Context/RandomInterval";
import { TimelineMax  , Power0 } from "gsap";
import { IInterval } from "../../Context/Interval";
import { ITitleGeneric } from "./ITitleGeneric";
import { JackpotDisplayType, Settings } from "../../Settings";

export class jackpotTitleSlide  implements ITitleGeneric{

    protected gameTitleSprite : PixiSpriteResource;
    protected jackpotTitleSprite : SpriteResource;
    protected systemContext : ISystemContext;
    protected logGroup  : LogGroup ;
    protected viewSize : Size;
    protected resid : ResourceIdentifier;
    protected view : HTMLElement  = null;
    protected titleSprite  : CanvasSprite;
    protected titleJackpotSprite  : CanvasSprite;
    protected Sprites : CanvasSprite[] =[];
    protected titleSpriteDelayTimer: IRandomInterval;
    protected jackpotTitleSpriteDelayTimer: IRandomInterval;
    protected currentLeftSlideIndex;
    protected canvasCurrentLeftSlide : CanvasSprite;
    protected nextLeftSlide : CanvasSprite;
    protected leftAnim: TimelineMax = null;
    protected readonly nextSlideInterval: number = 15 * 1000;
    protected nextSlideTimer: IInterval;
    protected started = false;
    protected basePath:string;
    protected gameName:string;

	
    
    constructor(params: titleParamsFeature) {
        //this.gameTitleSprite = params.gameTitleSprite;
        //this.jackpotTitleSprite = params.jackpotTitleSprite;
        this.systemContext = params.systemContext;
        this.logGroup = params.LogGroup;
        //this.viewSize = params.viewSize;
        this.resid = params.resid;
        this.basePath=params.basePath;
        this.gameName=params.gameName;
        
        this.view = CreateElement("div", {
            classes: ["jackpotTitleSlide"],
            style: {
                width : "100%",
                height : Scale.Hpx(460),
                display : "flex",      
                backgroundColor : "rbga(0,0,0,0.5)",          
            }
        })
    }

    public PrepareResources(resourceManager: ResourceManager) {
        resourceManager.Add(new SpriteResource(Settings.ResourcesFolder + "multigame/multigame/img/JackpotsResources-Slider/"+Settings.JackpotDisplayType+"/titleJackpotDisplay", this.resid.Add(Settings.JackpotDisplayType).Add("title-SlideJackpot"), true, this.logGroup.Add("title-SlideJackpot"), true));
        resourceManager.Add(new PixiSpriteResource(this.basePath + "resources/title_sprite2", this.resid.Add(this.gameName).Add("title-SlideGame"), true, this.logGroup.Add("title-SlideGame"), true));
        
    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.titleSprite = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(this.resid.Add(this.gameName).Add("title-SlideGame")).sprite, canvasSize: new Size(Scale.W(1920), Scale.H(460))});
        this.view.appendChild(this.titleSprite.View());
        //this.titleSprite.Start(true);
        this.titleSprite.ScaleNonUniform(1.1,1);
        this.titleSprite.View().style.position = "absolute";
        this.Sprites.push(this.titleSprite);

        
        this.titleJackpotSprite = new CanvasSprite({
            sprite: resourceManager.Get<SpriteResource>(this.resid.Add(Settings.JackpotDisplayType).Add("title-SlideJackpot")).sprite,
            canvasSize: new Size(Scale.W(1920), Scale.H(460))
        });
        this.view.appendChild(this.titleJackpotSprite.View());        
        
        let scaleX : number = 1.7;
        let scaleY : number = 1.5;        

        if(Settings.JackpotDisplayType != JackpotDisplayType.RapidDiamondPot ){
           scaleX = 1.2;
           scaleX = 1.1;
        }
        this.titleJackpotSprite.ScaleNonUniform(scaleX,scaleY);
        this.titleJackpotSprite.View().style.position = "absolute";
        this.titleJackpotSprite.View().style.display = "none";
        this.Sprites.push(this.titleJackpotSprite);

        this.createAnimInterval();
        //this.titleSpriteDelayTimer.Start();
    }  

    public Update(){
        this.titleSprite.Update();
        this.titleJackpotSprite.Update();
    }

    public View() : HTMLElement{
        return this.view
    } 
  
    protected createAnimInterval(){       
        this.nextSlideTimer = this.systemContext.TimingContext().CreateInterval("nextSlideTimer", this.nextSlideInterval, () => this.NextSlide());
        
		if (this.Sprites.length >=1)
		{
			this.currentLeftSlideIndex = 0;
			this.canvasCurrentLeftSlide = this.Sprites[0];
            this.titleSpriteDelayTimer = this.systemContext.TimingContext().CreateRandomInterval("titleSpriteDelay", 2000, 5000, () => this.canvasCurrentLeftSlide.Start(false));
		}


    }

    
    protected NextSlide()
	{
		let transitionMillis = 1000;
		let animDistance = 500;

		// left
		if (this.Sprites.length > 1)
		{
			
			let currentLeftSlide = this.canvasCurrentLeftSlide;

			let nextLeftSlideIndex = (this.currentLeftSlideIndex +1) % this.Sprites.length;
			let nextLeftSlide = this.Sprites[nextLeftSlideIndex];
			this.nextLeftSlide = nextLeftSlide;

			//// Log.Debug(this.logGroup, `NextSlide() currentLeftSlideIndex: ${this.currentLeftSlideIndex}, nextLeftSlideIndex: ${nextLeftSlideIndex}`);

			this.leftAnim = new TimelineMax({paused: true});

			// current slide: mode left fade out
			this.leftAnim.fromTo(this.canvasCurrentLeftSlide.View(), transitionMillis / 1000, {  autoAlpha: 1 , scale:1}, { autoAlpha: 0, scale: 0 ,display:"none"});

			// next slide: move right fade in
			this.leftAnim.fromTo(nextLeftSlide.View(), transitionMillis / 1000, { autoAlpha: 0, scale: 0 , display:"flex"}, {  autoAlpha: 1, scale: 1 }, "-=" + (transitionMillis / 1000));
            //let titleSpriteDelayTimer = this.systemContext.TimingContext().CreateRandomInterval("titleSpriteDelay", 3000, 5000, () => currentLeftSlide.Start(false));
			this.leftAnim.eventCallback("onStart", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition started, starting next slide");
				
                
                //titleSpriteDelayTimer.Stop();
			});

			this.leftAnim.eventCallback("onComplete", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition complete, stopping current slide");
				//currentLeftSlide.Stop();

				this.currentLeftSlideIndex = nextLeftSlideIndex;
				this.canvasCurrentLeftSlide = nextLeftSlide;
				this.nextLeftSlide = null;
                //titleSpriteDelayTimer.Start();
			});

			this.leftAnim.play();
		}
	}


	
    public Start(): void {
        if (!this.started) {
			this.started = true;
			this.nextSlideTimer.Start();
            this.titleSpriteDelayTimer.Start();

			// if (this.Sprites.length >= 1)
			// {
			// 	TweenLite.set(this.currentLeftSlideIndex.View(), {scale: 1, autoAlpha: 1});
			// 	this.nextLeftSlide.Start();
			// }			
		}
		else
		{
			// already started
		}
    }

    public Stop(): void {
		if (this.started)
		{
			this.started = false;
			this.nextSlideTimer.Stop();
            this.titleSpriteDelayTimer.Stop();		
		}
    }
}